import { render, staticRenderFns } from "./VCarousel.vue?vue&type=template&id=ecba9df0&scoped=true"
import script from "./VCarousel.vue?vue&type=script&lang=js"
export * from "./VCarousel.vue?vue&type=script&lang=js"
import style0 from "./VCarousel.vue?vue&type=style&index=0&id=ecba9df0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecba9df0",
  null
  
)

export default component.exports